"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.VagueNode = exports.VagueNodeQueryError = exports.VagueNodeStatus = exports.isValidIndex = void 0;
/* eslint-disable no-restricted-syntax */
const __1 = require("..");
const get_1 = __importDefault(require("./get"));
const path_1 = require("./path");
const find = (iterator, predicate) => {
    while (true) {
        const x = iterator.next();
        if (typeof x.value !== 'undefined' && predicate(x.value))
            return x.value;
        if (x.done)
            return;
    }
};
const getModUtilToNode = (node, modifiedBy) => {
    if (!node.isCreatedFromAssignedValue) {
        return {
            get: () => node.newValue,
            set: (value) => {
                node.applySet(modifiedBy, value);
            },
            delete: () => {
                node.applyDelete(modifiedBy);
            },
        };
    }
    const { id } = node;
    const relPath = [];
    const root = find(node.parents(), (maybeRoot) => {
        if (!maybeRoot.isCreatedFromAssignedValue)
            return true;
        relPath.unshift(maybeRoot.id);
        return false;
    });
    return {
        get: () => { var _a; return (_a = (0, get_1.default)(root === null || root === void 0 ? void 0 : root.newValue, relPath)) === null || _a === void 0 ? void 0 : _a[id]; },
        set: (value) => {
            const fork = (0, get_1.default)(root === null || root === void 0 ? void 0 : root.newValue, relPath);
            if (fork && typeof fork === 'object')
                fork[id] = value;
        },
        delete: () => {
            const fork = (0, get_1.default)(root === null || root === void 0 ? void 0 : root.newValue, relPath);
            if (fork && typeof fork === 'object')
                delete fork[id];
        },
    };
};
const isValidIndex = (x) => Number.isInteger(x) && x >= 0;
exports.isValidIndex = isValidIndex;
var VagueNodeStatus;
(function (VagueNodeStatus) {
    VagueNodeStatus[VagueNodeStatus["NOT_TOUCHED"] = 0] = "NOT_TOUCHED";
    VagueNodeStatus[VagueNodeStatus["DELETED"] = 1] = "DELETED";
    VagueNodeStatus[VagueNodeStatus["ASSIGNED"] = 2] = "ASSIGNED";
    VagueNodeStatus[VagueNodeStatus["ARRAY_RESORTED"] = 3] = "ARRAY_RESORTED";
})(VagueNodeStatus = exports.VagueNodeStatus || (exports.VagueNodeStatus = {}));
class VagueNodeQueryError extends Error {
    constructor(throwFrom, queryPath, reason) {
        super(`Cannot query /${queryPath.join('/')} from /${throwFrom.getPath().join('/')}, ${VagueNodeQueryError.reasonMessages[reason]}`);
        this.throwFrom = throwFrom;
        this.queryPath = queryPath;
        this.reason = reason;
    }
}
exports.VagueNodeQueryError = VagueNodeQueryError;
VagueNodeQueryError.reasonMessages = {
    parentDeleted: 'the owner node is deleted',
    parentResorted: 'the owner node is resorted array and the queried node is dropped',
};
class VagueNode {
    applyDelete(modifiedBy) {
        if (this.isCreatedFromAssignedValue) {
            getModUtilToNode(this, modifiedBy).delete();
            return;
        }
        this.clearChildren();
        this.markDirty();
        this.isResortedArray = void 0;
        this.status = VagueNodeStatus.DELETED;
        this.newValue = void 0;
        this.lastModifiedBy = modifiedBy;
    }
    applySet(modifiedBy, newValue) {
        if (this.isCreatedFromAssignedValue) {
            getModUtilToNode(this, modifiedBy).set(newValue);
            return;
        }
        this.clearChildren();
        this.markDirty();
        this.isResortedArray = void 0;
        this.status = VagueNodeStatus.ASSIGNED;
        this.newValue = newValue;
        this.lastModifiedBy = modifiedBy;
    }
    applyResort(modifiedBy, indexMap) {
        var _a;
        if (this.status === VagueNodeStatus.DELETED) {
            throw new Error('Cannot apply resortArray on a deleted node');
        }
        if (this.status === VagueNodeStatus.ASSIGNED) {
            const arr = this.newValue;
            if (!Array.isArray(arr))
                throw new Error('Cannot apply resortArray on non-array node');
            this.newValue = indexMap.map(oi => arr[oi]);
            return;
        }
        if (this.isCreatedFromAssignedValue) {
            const { get, set } = getModUtilToNode(this, modifiedBy);
            const arr = get();
            if (!Array.isArray(arr))
                throw new Error('Cannot apply resortArray on non-array node');
            set(indexMap.map(oi => arr[oi]));
            // isArray 和 newValue 在这个节点上已经没有任何意义了
            return;
        }
        // ---------------------------------------------
        // change
        const droppedChildren = ((_a = this.isResortedArray) === null || _a === void 0 ? void 0 : _a.droppedChildren) || new Set();
        {
            const preservedNodes = new Map();
            indexMap.forEach((oi, ni) => {
                const subNode = oi === -1 ? new VagueNode('-1', this) : this.queryPath([String(oi)]);
                preservedNodes.set(subNode, String(ni));
            });
            // second pass: update the id
            this.children.forEach((subNode) => {
                if (!preservedNodes.has(subNode)) {
                    if ((0, exports.isValidIndex)(+subNode.originalId))
                        droppedChildren.add(subNode);
                    subNode.remove();
                }
                else {
                    // eslint-disable-next-line no-param-reassign
                    subNode.id = preservedNodes.get(subNode);
                }
            });
        }
        this.markDirty();
        this.isResortedArray = { length: indexMap.length, droppedChildren };
        this.status = VagueNodeStatus.ARRAY_RESORTED;
        this.newValue = void 0;
        this.lastModifiedBy = modifiedBy;
    }
    /**
     * 应用一个 patch 到当前节点（注意，这里 patch.path 会被忽略！！！！！）
     */
    applyPatch(modifiedBy, patch) {
        switch (patch.op) {
            case 'set':
                this.applySet(modifiedBy, patch.value);
                break;
            case 'delete':
                this.applyDelete(modifiedBy);
                break;
            case 'resortArray':
                this.applyResort(modifiedBy, patch.indexMap);
                break;
            case 'spliceArray':
            default:
                throw new Error(`Unknown operation ${patch.op}`);
        }
    }
    // eslint-disable-next-line no-useless-constructor
    constructor(id, parent) {
        this.children = new Set();
        this.isCreatedFromAssignedValue = false;
        this.status = VagueNodeStatus.NOT_TOUCHED;
        this.newValue = void 0;
        this.isDirty = false;
        this.id = id;
        this.originalId = id;
        this.originalPath = parent ? parent.originalPath.concat(id) : [];
        if (parent) {
            this.isCreatedFromAssignedValue = parent.isCreatedFromAssignedValue || parent.status === VagueNodeStatus.ASSIGNED;
            this.appendTo(parent);
        }
    }
    append(...children) {
        children.forEach(child => child.appendTo(this));
    }
    clearChildren() {
        this.children.forEach(child => child.remove());
    }
    queryPath(path, opts = {}) {
        const p = Array.isArray(path) ? path : (0, path_1.toPathParts)(path);
        if (!p.length)
            return this;
        const chId = p[0];
        const checkOriginalId = !!opts.checkOriginalIdUntilMeetNodeModifiedBy;
        const idSource = checkOriginalId ? 'originalId' : 'id';
        let ch = find(this.children.values(), maybeCh => maybeCh[idSource] === chId);
        if (!ch) {
            // 在有些 case 下不能帮他创建
            if (checkOriginalId) {
                if (this.status === VagueNodeStatus.ARRAY_RESORTED)
                    throw new VagueNodeQueryError(this, p, 'parentResorted');
                if (this.status === VagueNodeStatus.DELETED)
                    throw new VagueNodeQueryError(this, p, 'parentDeleted');
            }
            ch = new VagueNode(chId, this);
        }
        if (p.length === 1)
            return ch;
        if (checkOriginalId && ch.lastModifiedBy === opts.checkOriginalIdUntilMeetNodeModifiedBy) {
            // eslint-disable-next-line no-param-reassign
            opts = { ...opts, checkOriginalIdUntilMeetNodeModifiedBy: undefined };
        }
        return ch.queryPath(p.slice(1), opts);
    }
    appendTo(parent) {
        if (this.parent)
            this.remove();
        this.parent = parent;
        parent.children.add(this);
    }
    remove() {
        if (!this.parent)
            return;
        this.parent.children.delete(this);
        this.parent = undefined;
    }
    getPath() {
        if (!this.parent)
            return []; // 找到了根节点，此时 id 是无意义的
        return this.parent.getPath().concat(this.id);
    }
    *parents() {
        let ptr = this.parent;
        while (ptr) {
            yield ptr;
            ptr = ptr.parent;
        }
    }
    markDirty() {
        let ptr = this;
        while (ptr && !ptr.isDirty) {
            ptr.isDirty = true;
            ptr = ptr.parent;
        }
    }
    /**
     * reset 当前节点的编辑状态
     *
     * 对于数组而言，这个会试图重建一个来自最原始数组的 children，
     * 以便实现 findConflicts 的时间回溯能力
     */
    reset() {
        // 特殊的逻辑：如果这个是一个 resorted array 被 reset
        // 需要重构 children，以便对数组原有元素的修改仍在
        const newChildrenForArray = [];
        const { isResortedArray } = this;
        if (isResortedArray) {
            newChildrenForArray.push(...Array.from(isResortedArray.droppedChildren));
            this.children.forEach((node) => {
                if ((0, exports.isValidIndex)(+node.originalId))
                    newChildrenForArray.push(node);
            });
        }
        // 不要修改ID，因为是外部赋予的
        let isDirty = false;
        this.clearChildren();
        newChildrenForArray.forEach((node) => {
            // eslint-disable-next-line no-param-reassign
            node.id = node.originalId;
            node.appendTo(this);
            if (node.isDirty)
                isDirty = true;
        });
        this.isDirty = isDirty;
        this.newValue = void 0;
        this.isResortedArray = void 0;
        this.status = VagueNodeStatus.NOT_TOUCHED;
        this.lastModifiedBy = void 0;
    }
    *toPatches(path, options = {}) {
        if (!this.isDirty)
            return; // 一般用于数组项
        const { filter } = options;
        if (filter && !filter(this))
            return;
        if (this.status === VagueNodeStatus.DELETED) {
            yield { op: 'delete', path };
            return;
        }
        if (this.status === VagueNodeStatus.ASSIGNED) {
            yield { op: 'set', path, value: this.newValue };
            return;
        }
        if (this.status === VagueNodeStatus.ARRAY_RESORTED) {
            // FIXME: 不知道原来数组的长度，因此总是要 resort 一下
            const indexMap = new Array(this.isResortedArray.length).fill(-1);
            this.children.forEach((node) => {
                const oi = +node.originalId;
                const ni = +node.id;
                if (!(0, exports.isValidIndex)(oi) || !(0, exports.isValidIndex)(ni))
                    return;
                indexMap[ni] = oi;
            });
            yield { op: 'resortArray', path, indexMap };
            // 不要立即 return ，因为还需要遍历子节点
        }
        for (const child of this.children) {
            yield* child.toPatches((0, __1.pushPath)(path, child.id), options);
        }
    }
}
exports.VagueNode = VagueNode;
